import AppConfig from '../types/app-config'
import { StaticParamsBase } from '../types/common'
import { AppSpinner } from './AppSpinner'

export class Inlet {
  appElement: Element
  inletElement: Element
  appSpinner: AppSpinner

  constructor(public appName: string, public version: string, public paramsFile?: AppConfig) {
    this.#init()
  }

  #getWidgetElement(appName: string): Element {
    return (document.querySelector('[widget="' + appName + '"]:not([initialized])') ||
      document.querySelector('[data-widget="' + appName + '"]:not([initialized])')) as Element
  }

  #prepareDOM() {
    const element = this.#getWidgetElement(this.appName)
    if (!element) {
      throw new Error('Inlet element not found!')
    }

    element.setAttribute('initialized', 'true')
    element.setAttribute('data-version', this.version)

    this.appSpinner = new AppSpinner(element as HTMLElement)
    this.inletElement = element
    this.appElement = element.insertAdjacentElement('afterbegin', document.createElement('div')) as Element
  }

  #init() {
    this.#prepareDOM()
    console.info(
      `Inlet: ${this.appName} - instance: ${this.getStaticParams().instanceId}, version: ${this.version} loaded`
    )
  }

  getStaticParams<T extends StaticParamsBase>() {
    return JSON.parse(
      this.inletElement.getAttribute('params') || this.inletElement.getAttribute('data-params') || '{}'
    ) as T
  }
}
